export interface Preset {
    id: number;
    name: string;
    isHome: boolean;
}

export interface StreamMetaPermissions {
    controlPtzf: boolean;
    controlPresets: boolean;
    quickSounds: boolean;
    speakerTalkdown: boolean;
    suspendPatrol: boolean;
}
export const defaultPermissions = (): StreamMetaPermissions => ({
    controlPtzf: true,
    controlPresets: true,
    quickSounds: true,
    speakerTalkdown: true,
    suspendPatrol: true,
});

export interface StreamMetaCapabilities {
    autofocus: boolean;
    clickToCenter: boolean;
    heater: boolean;
    home: boolean;
    lightInternal: boolean;
    lightInfared: boolean;
    pan: boolean;
    panStop: boolean;
    position: boolean;
    presets: boolean;
    relayActions: RelayAction[];
    speakerSounds: SpeakerSound[];
    speakerTalkdown: boolean;
    snapshot: boolean;
    zoom: boolean;
    webrtc: boolean;
}
export const defaultCameraCapabilities = (): StreamMetaCapabilities => ({
    autofocus: true,
    clickToCenter: true,
    heater: true,
    home: true,
    lightInternal: true,
    lightInfared: true,
    pan: true,
    panStop: true,
    position: true,
    presets: true,
    relayActions: [],
    speakerSounds: [],
    speakerTalkdown: true,
    snapshot: true,
    zoom: true,
    webrtc: true,
});

export interface SpeakerSound { id: number; label: string; }

export interface RelayAction {
    /**
     * Camera id associated with the relay
     */
    cameraId?: number;
    /**
     * Relay type (i.e. flood)
     */
    relayName: string;
    /**
     * User-facing name for the relay action (i.e. Flood Light)
     */
    uiLabel?: string;
    /**
     * Default position of the relay (on/off)
     */
    stateDefault?: boolean;
    /**
     * TODO
     */
    reportStates: boolean;
    /**
     * Delay in milliseconds before setting the relay to it's default state
     */
    delay: number | null;
}

export const getLights = (relays: RelayAction[]) => {
    return relays.filter((relay) => (
        relay.relayName.toLowerCase().indexOf("light") !== -1 ||
        relay.relayName.toLowerCase().indexOf("strobe") !== -1
    ));
};

export const getHeater = (relays: RelayAction[]) => {
    return relays.filter((relay) => relay.relayName.toLowerCase().indexOf("heater") !== -1)[0];
};

export interface StreamMeta {
    cameraId: number;
    cameraName: null | string;
    cameraActive: boolean;
    cameraPatrolSuspended: boolean;
    cameraHealth: CameraHealth;
    capabilities: StreamMetaCapabilities;
    liveUnitId: number;
    liveUnitName: string;
    sipPhoneNumber: null | string;
    sipPin: null | string;
    clientPasscode: null | number;
    locationId: number;
    locationName: string;
    clientId: number;
    clientName: string;
    clientLogoUrl: null | string;
    otherCameraIds: Array<number>;
    timeZone: string;
    permissions: StreamMetaPermissions;
    presets: Array<Preset>;
}

export const defaultStreamMeta = (camId?: number): StreamMeta => ({
    cameraId: camId || 1,
    cameraName: null,
    cameraActive: false,
    cameraPatrolSuspended: false,
    cameraHealth: defaultCameraHealth(),
    capabilities: defaultCameraCapabilities(),
    liveUnitId: 0,
    liveUnitName: "",
    sipPhoneNumber: null,
    sipPin: null,
    clientPasscode: null,
    locationId: 0,
    locationName: "",
    clientId: 0,
    clientName: "",
    clientLogoUrl: null,
    otherCameraIds: [],
    timeZone: "",
    permissions: defaultPermissions(),
    presets: [],
});

// TODO: Use UnitHealth instead
export interface CameraHealth {
    isFlapping: boolean;
    isGradient: boolean;
    statusText: string;
    startColor: string;
    color: string;
    overlay: string | null;
}

export const defaultCameraHealth = (): CameraHealth => ({
    isFlapping: false,
    isGradient: false,
    statusText: "",
    startColor: "",
    color: "",
    overlay: null,
});
